import { ICloseRequirements } from '@user/store/opportunity/typings'

export function reasonTypeToString(type: ICloseRequirements['type']) {
  switch (type) {
    case 'Agreements':
      return 'Agreement'
    default:
      return type
  }
}
